import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@revvsales/components";

const NoteAttachments = props => (
  <div>
    <ul className="attachments-wrapper">
      {props.attachments.map(item => (
        <li className="attachments-item">
          <a href={item.Link} data-test="notesattachment-link">
            <i>
              <FontAwesomeIcon icon={["far", "file-alt"]} />
            </i>
            {item.Identifier}
          </a>
          {props.removeAttachment && (
            <Button
              className="btn-icon remove-attachment"
              onClick={() => props.removeAttachment(item.Link)}
              data-test="notesattachment-btn">
              <span>
                <FontAwesomeIcon icon={["far", "times-circle"]} />
              </span>
            </Button>
          )}
        </li>
      ))}
    </ul>
  </div>
);

export default NoteAttachments;



// WEBPACK FOOTER //
// ./src/components/Notes/NotesAttachment.js